"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
'kiwi public'; // eslint-plugin-vue's max-len rule reads the entire file, including the CSS. so we can't use this
// here as some of the rules cannot be broken up any smaller

/* eslint-disable max-len */

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _indexOf = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/index-of"));

var _TextFormatting = require("@/helpers/TextFormatting");

var _MessageInfo = _interopRequireDefault(require("./MessageInfo"));

var _MessageListAvatar = _interopRequireDefault(require("./MessageListAvatar"));

var _AwayStatusIndicator = _interopRequireDefault(require("./AwayStatusIndicator"));

var _TypingStatusIndicator = _interopRequireDefault(require("./TypingStatusIndicator"));

var _MediaViewer = _interopRequireDefault(require("./MediaViewer"));

var _default = {
  components: {
    MessageAvatar: _MessageListAvatar.default,
    MessageInfo: _MessageInfo.default,
    AwayStatusIndicator: _AwayStatusIndicator.default,
    TypingStatusIndicator: _TypingStatusIndicator.default,
    MediaViewer: _MediaViewer.default
  },
  props: ['ml', 'message', 'idx'],
  data: function data() {
    return {};
  },
  computed: {
    showRealName: function showRealName() {
      // Showing realname is not enabled
      if (!this.ml.buffer.setting('show_realnames')) {
        return false;
      } // Server does not support extended-join so realname would be inconsistent


      var client = this.ml.buffer.getNetwork().ircClient;

      if (!client.network.cap.isEnabled('extended-join')) {
        return false;
      } // We dont have a user or users realname


      if (!this.message.user || !this.message.user.realname) {
        return false;
      } // No point showing the realname if it's the same as the nick


      if (this.message.user.nick.toLowerCase() === this.message.user.realname.toLowerCase()) {
        return false;
      } // If the realname contains a URL it's most likely a clients website


      if (_TextFormatting.urlRegex.test(this.message.user.realname)) {
        return false;
      }

      return true;
    },
    userColour: function userColour() {
      return this.ml.userColour(this.message.user);
    }
  },
  methods: {
    getNetwork: function getNetwork() {
      return this.ml.buffer.getNetwork();
    },
    isRepeat: function isRepeat() {
      var ml = this.ml;
      var idx = this.idx;
      var message = this.message;
      var prevMessage = ml.filteredMessages[idx - 1];
      return !!prevMessage && prevMessage.nick === message.nick && message.time - prevMessage.time < 60000 && prevMessage.type !== 'traffic' && message.type !== 'traffic' && message.type === prevMessage.type;
    },
    isHoveringOverMessage: function isHoveringOverMessage(message) {
      return message.nick && message.nick.toLowerCase() === this.hover_nick.toLowerCase();
    },
    isMessage: function isMessage(message) {
      var types = ['privmsg', 'action', 'notice', 'message'];
      return (0, _indexOf.default)(types).call(types, message.type) > -1;
    },
    displayAvatar: function displayAvatar(message) {
      // if there is no user attached hide the avatar
      if (!message.user) {
        return false;
      } // dont show avatars in server or special buffers


      if (this.ml.buffer.isServer() || this.ml.buffer.isSpecial()) {
        return false;
      }

      return true;
    },
    userMode: function userMode(user) {
      return this.ml.buffer.userMode(user);
    },
    userModePrefix: function userModePrefix(user) {
      return this.ml.buffer.userModePrefix(user);
    }
  }
};
exports.default = _default;
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["MessageListMessageModern"]
window._kiwi_exports.components.MessageListMessageModern = exports.default ? exports.default : exports;
